var _circle, _path, _path2, _path3, _path4, _circle2, _circle3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRxPrecribed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 15,
    fill: "#0C585B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0716 25.8027L20.9712 22.9316C20.5387 22.3392 20.1062 21.9427 19.6736 21.7422C19.2411 21.5371 18.6986 21.4346 18.0461 21.4346H16.0887V25.8027H15V16H19.3767C20.7696 16 21.862 16.2347 22.6537 16.7041C23.4528 17.1689 23.8524 17.7842 23.8524 18.5498C23.8524 19.2562 23.5261 19.8464 22.8737 20.3203C22.2212 20.7943 21.3085 21.0996 20.1355 21.2363V21.2637C20.7586 21.4186 21.3671 21.8903 21.9609 22.6787L24.3032 25.8027H23.0716ZM16.0887 16.6221V20.8193H18.8049C20.0072 20.8193 20.9602 20.6234 21.664 20.2314C22.3751 19.8395 22.7307 19.3018 22.7307 18.6182C22.7307 17.9938 22.4118 17.5062 21.774 17.1553C21.1362 16.7998 20.2235 16.6221 19.0358 16.6221H16.0887Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1731 26.5684L28.846 30H27.25L24.3978 27.2887H24.3032L24.1504 27.4365C24.0991 27.4912 24.0368 27.5527 23.9635 27.6211L22 30H20.2466L23.3125 26.0625L21.0212 23H22.2089L24.0075 25.5088C24.3301 25.8324 24.0845 25.5215 24.1504 25.5989L24.3978 25.8027L25.1731 25.1875L27.25 23H29L25.1731 26.5684Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0716 25.8027L20.9712 22.9316C20.5387 22.3392 20.1062 21.9427 19.6736 21.7422C19.2411 21.5371 18.6986 21.4346 18.0461 21.4346H16.0887V25.8027H15V16H19.3767C20.7696 16 21.862 16.2347 22.6537 16.7041C23.4528 17.1689 23.8524 17.7842 23.8524 18.5498C23.8524 19.2562 23.5261 19.8464 22.8737 20.3203C22.2212 20.7943 21.3085 21.0996 20.1355 21.2363V21.2637C20.7586 21.4186 21.3671 21.8903 21.9609 22.6787L24.3032 25.8027H23.0716ZM16.0887 16.6221V20.8193H18.8049C20.0072 20.8193 20.9602 20.6234 21.664 20.2314C22.3751 19.8395 22.7307 19.3018 22.7307 18.6182C22.7307 17.9938 22.4118 17.5062 21.774 17.1553C21.1362 16.7998 20.2235 16.6221 19.0358 16.6221H16.0887Z",
    stroke: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1731 26.5684L28.846 30H27.25L24.3978 27.2887H24.3032L24.1504 27.4365C24.0991 27.4912 24.0368 27.5527 23.9635 27.6211L22 30H20.2466L23.3125 26.0625L21.0212 23H22.2089L24.0075 25.5088C24.3301 25.8324 24.0845 25.5215 24.1504 25.5989L24.3978 25.8027L25.1731 25.1875L27.25 23H29L25.1731 26.5684Z",
    stroke: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 21.75,
    stroke: "#0581C8",
    strokeWidth: 0.5
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 22,
    r: 19.5,
    stroke: "#0581C8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRxPrecribed);
export default __webpack_public_path__ + "static/media/rx_precribed.b86c9a39944b0481eb2243c1c0463f65.svg";
export { ForwardRef as ReactComponent };